/**
 * safeReturnUrl — open-redirect guard for the post-sign-in returnUrl
 * (epic-uat-portal-001-8). Only a SAME-ORIGIN, path-style value is honoured;
 * anything that escapes the origin (`//evil`, `https://evil`, `javascript:`,
 * backslash / control-char tricks) falls back to `/app`.
 */
export function safeReturnUrl(raw: string | null): string {
  if (!raw) return '/app';
  // eslint-disable-next-line no-control-regex
  if (/[\\\x00-\x1F\x7F]/.test(raw)) return '/app';
  try {
    const u = new URL(raw, window.location.origin);
    if (u.origin !== window.location.origin) return '/app';
    const result = `${u.pathname}${u.search}${u.hash}`;
    // Validate the RETURNED value too (parser/normalization differential): a raw
    // like `/.//evil` normalizes to a `//evil` pathname that passes the origin
    // check but is protocol-relative to a consumer. Reject a result that doesn't
    // read as a single same-origin path.
    if (!result.startsWith('/') || result.startsWith('//') || result.startsWith('/\\')) return '/app';
    return result;
  } catch {
    return '/app';
  }
}
